
import CryptoJS from 'crypto-js'


export function getAesString(data) {
  // let keys = CryptoJS.enc.Utf8.parse('lHtZqNE9BVdB8457')
  let keys = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_secretKey)
  let vis = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_iv)
  // let vis = CryptoJS.enc.Utf8.parse('K5VjFPEzh5rUlfi4')
  let encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), keys, {
    iv: vis, //iv偏移量 CBC需加偏移量
    mode: CryptoJS.mode.CBC, //CBC模式
    // mode: CryptoJS.mode.ECB, //ECB模式
    padding: CryptoJS.pad.Pkcs7 //padding处理
  });
  // debugger
  return CryptoJS.enc.Base64.stringify(encrypt.ciphertext);
  // return encrypt.toString(); //加密完成后，转换成字符串

}

export function decryptAesString(encryptedData) {
  let keys = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_secretKey);  // 加密时使用的key
  let vis = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_iv);  // 加密时使用的IV偏移量

  // 使用 Base64 解码（因为加密时用了 Base64 编码）
  let decrypted = CryptoJS.AES.decrypt(encryptedData, keys, {
    iv: vis,  // IV偏移量与加密时一致
    mode: CryptoJS.mode.CBC,  // 使用CBC模式
    padding: CryptoJS.pad.Pkcs7  // padding处理与加密时一致
  });

  // 转换回原始的 JSON 字符串
  let decryptedData = CryptoJS.enc.Utf8.stringify(decrypted);

  // 如果加密时传递的数据是JSON对象，解密后将字符串解析回对象
  return JSON.parse(decryptedData);
}